import {NoteRowInterface} from "./NoteRowInterface";
import moment from "moment";
import {useNavigate} from "react-router-dom";


export const NoteListRow = (props: NoteRowInterface) => {

    const navigate = useNavigate();
    
    return (
        <tr onClick={() => navigate(`/notes/${props.note.id}/edit`)}>
            <td>{props.rowIndex}</td>
            <td>{props.note.subject}</td>
            <td>
                <input
                    disabled={true}
                    type={"checkbox"}
                    checked={props.note.archived}/>
            </td>
            <td>{props.note?.created &&
                moment(props.note?.created, moment.ISO_8601)?.format('YYYY-MM-DD HH:mm:ss')}
            </td>
            <td>{props.note?.lastModified &&
                moment(props.note?.lastModified, moment.ISO_8601)?.format('YYYY-MM-DD HH:mm:ss')}
            </td>
        </tr>
    )
}
